// A Bridge host (COMPONENTS.md → Bridge): lottie-web draws inside this node,
// DOMQL owns the node itself.
//
// lottie-web keeps every animation it loads, with its frame loop, until the
// animation's own `destroy()`. This component loaded in `onRender` and dropped
// the handle, so nothing ever stopped one (shared item 24, 2026-11-01): a
// removal (a page swap, a removed parent) left it running, an element that
// went before `lottie-web` loaded still got one, and each `if:` re-show fired
// `onRender` again (a second SVG and a second loop in the same node). The
// bridge mounts once per connected node, keeps its animation through an `if:`
// hide, and destroys it exactly once per started mount, a late mount included.
export const Lottie = {
  extends: 'Bridge',
  src: 'resize.json',
  boxSize: '3.2em',
  onBridgeMount: async (node, el) => {
    const lottie = await import('lottie-web')
    const player = lottie.default || lottie

    let src = el.call('exec', el.src, el)
    if (!src) return
    if (el.call('isString', src) && src.includes('{{')) {
      src = el.call('replaceLiteralsWithObjectFields', src)
    }

    return player.loadAnimation({
      container: node,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `https://assets.symbo.ls/lottie/${src}`
    })
  },
  onBridgeDestroy: (animation) => animation && animation.destroy()
}
